import { render } from "./SlotBadges.vue?vue&type=template&id=0013c5fb&scoped=true"
import script from "./SlotBadges.vue?vue&type=script&lang=js"
export * from "./SlotBadges.vue?vue&type=script&lang=js"

import "./SlotBadges.vue?vue&type=style&index=0&id=0013c5fb&scoped=true&lang=css"
import "./SlotBadges.vue?vue&type=style&index=1&id=0013c5fb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0013c5fb"]])

export default __exports__